var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleVine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 684,
    height: 271,
    viewBox: "0 0 684 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1699 143.956C67.4594 160.369 52.5464 155.7 52.5464 155.7C52.5464 155.7 40.6999 145.5 50.0466 129.452C59.4055 113.396 85.1964 97.0017 85.1964 97.0017C85.1964 97.0017 84.8683 127.551 76.1578 143.964L76.1699 143.956Z",
    fill: "#81C341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4011 155.484L78.9219 107.713",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4011 155.484L78.9219 107.713",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6547 153.337L53.6797 136.09",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5052 138.946L72.5063 132.439",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9373 127.468L68.9922 114.852",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3719 115.983L79.4883 112.648",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1699 143.956C67.4594 160.369 52.5464 155.7 52.5464 155.7C52.5464 155.7 40.6999 145.5 50.0466 129.452C59.4055 113.396 85.1964 97.0017 85.1964 97.0017C85.1964 97.0017 84.8683 127.551 76.1578 143.964L76.1699 143.956Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M467.1 54.3898C463.046 46.5287 455.922 48.6672 455.922 48.6672C455.922 48.6672 450.226 53.4557 454.585 61.1469C458.949 68.8419 471.133 76.7902 471.133 76.7902C471.133 76.7902 471.149 62.247 467.095 54.3859L467.1 54.3898Z",
    fill: "#81C341"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M455.852 48.7691L468.207 71.6562",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M455.852 48.7691L468.207 71.6562",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M456.436 49.7963L456.352 58.0059",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M460.092 56.6914L465.291 59.8506",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M463.088 62.1919L463.52 68.2031",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M466.087 67.6955L468.504 69.3115",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M467.1 54.3898C463.046 46.5287 455.922 48.6672 455.922 48.6672C455.922 48.6672 450.226 53.4557 454.585 61.1469C458.949 68.8419 471.133 76.7902 471.133 76.7902C471.133 76.7902 471.149 62.247 467.095 54.3859L467.1 54.3898Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.0924 249.367C-28.0924 249.367 25.0227 243.059 44.2965 223.183C63.5702 203.306 68.6183 175.585 67.8342 154.727C67.0501 133.868 69.2239 103.751 82.5865 84.0969C93.8243 67.5682 127.821 42.5494 170.908 42.6709C213.994 42.7924 257.259 72.7297 296.908 62.5339C336.556 52.3381 352.908 52.9511 399.908 53.0375C430.52 54.802 500.782 70.0337 545.408 70.5339C553.086 70.6216 582.666 65.1538 594.908 58.4296C615.908 46.8951 617.5 46.5 620.499 44.5002C635.178 34.7108 628 28.5 638 36.5C652 47.7 641.5 36.5 641.5 36.5C641.5 36.5 637 29.5 632.5 29.5C628 29.5 625.499 31 620.499 36.5C615.499 42 611.408 43.6572 576.908 54.5339C556.308 61.0282 541.408 58.4296 520.367 58.4296C503.467 52.8531 439.408 51.517 399.908 53.0375C385.908 52.7022 352.233 53.0375 310.908 53.0375C294.908 50.7883 271.18 47.613 221.908 30.5339C202.705 23.8799 174.011 20.2675 140.908 25.3653C110.079 30.1167 68.2252 55.1637 53.3253 87.1687C41.8233 111.881 43.3174 144.69 42.7866 159.928C42.2101 176.488 34.4936 188.203 21.7533 196.519C9.01292 204.835 -29.2448 207.097 -29.2448 207.097L-56.0899 223.182L-28.0924 249.367Z",
    fill: "#60933F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.0924 249.367C-28.0924 249.367 25.0227 243.059 44.2965 223.183C63.5702 203.306 68.6183 175.585 67.8342 154.727C67.0501 133.868 69.2239 103.751 82.5865 84.0969C93.8243 67.5682 127.821 42.5494 170.908 42.6709C213.994 42.7924 257.259 72.7297 296.908 62.5339C336.556 52.3381 352.908 52.9511 399.908 53.0375C430.52 54.802 500.782 70.0337 545.408 70.5339C553.086 70.6216 582.666 65.1538 594.908 58.4296C615.908 46.8951 617.5 46.5 620.499 44.5002C635.178 34.7108 628 28.5 638 36.5C652 47.7 641.5 36.5 641.5 36.5C641.5 36.5 637 29.5 632.5 29.5C628 29.5 625.499 31 620.499 36.5C615.499 42 611.408 43.6572 576.908 54.5339C556.308 61.0282 541.408 58.4296 520.367 58.4296C503.467 52.8531 439.408 51.517 399.908 53.0375C385.908 52.7022 352.233 53.0375 310.908 53.0375C294.908 50.7883 271.18 47.613 221.908 30.5339C202.705 23.8799 174.011 20.2675 140.908 25.3653C110.079 30.1167 68.2252 55.1637 53.3253 87.1687C41.8233 111.881 43.3174 144.69 42.7866 159.928C42.2101 176.488 34.4936 188.203 21.7533 196.519C9.01292 204.835 -29.2448 207.097 -29.2448 207.097L-56.0899 223.182L-28.0924 249.367Z",
    fill: "url(#paint0_linear_6177_11816)",
    fillOpacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.684 19.0561C133.944 24.1298 136.482 33.7918 136.482 33.7918C136.482 33.7918 142.642 41.6602 153.168 36.1693C163.7 30.671 174.936 14.6897 174.936 14.6897C174.936 14.6897 155.419 13.9899 144.679 19.0636L144.684 19.0561Z",
    fill: "#81C341"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.616 33.8913L167.91 18.3779",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.616 33.8913L167.91 18.3779",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.021 33.1549L149.035 33.6523",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.448 28.5701L151.931 21.7389",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.971 24.804L163.059 24.5059",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M162.496 21.038L164.777 17.8701",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.684 19.0561C133.944 24.1298 136.482 33.7918 136.482 33.7918C136.482 33.7918 142.642 41.6602 153.168 36.1693C163.7 30.671 174.936 14.6897 174.936 14.6897C174.936 14.6897 155.419 13.9899 144.679 19.0636L144.684 19.0561Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8036 240.28C38.3122 228.666 28.3262 228.933 28.3262 228.933C28.3262 228.933 19.2604 233.138 22.2066 244.638C25.1589 256.146 38.1572 270.731 38.1572 270.731C38.1572 270.731 43.2888 251.886 40.7975 240.273L40.8036 240.28Z",
    fill: "#81C341"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1985 229.042L36.168 263.049",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1985 229.042L36.168 263.049",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5933 230.579L25.5977 241.189",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9119 240.8L36.5411 246.723",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8625 248.984L31.3086 256.927",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8108 257.169L37.375 260.113",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8036 240.28C38.3122 228.666 28.3262 228.933 28.3262 228.933C28.3262 228.933 19.2604 233.138 22.2066 244.638C25.1589 256.146 38.1572 270.731 38.1572 270.731C38.1572 270.731 43.2888 251.886 40.7975 240.273L40.8036 240.28Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 642.04,
    cy: 42.6114,
    rx: 2.28415,
    ry: 5.74167,
    transform: "rotate(127.672 642.04 42.6114)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 672.505,
    cy: 58.8058,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(127.672 672.505 58.8058)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 659.11,
    cy: 45.8009,
    rx: 2.81126,
    ry: 7.06667,
    transform: "rotate(127.672 659.11 45.8009)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 643.946,
    cy: 39.421,
    rx: 2.81126,
    ry: 7.06667,
    transform: "rotate(127.672 643.946 39.421)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 645.61,
    cy: 35.8214,
    rx: 2.81126,
    ry: 7.06667,
    transform: "rotate(127.672 645.61 35.8214)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.817,
    cy: 40.9425,
    rx: 2.81126,
    ry: 7.06667,
    transform: "rotate(127.672 652.817 40.9425)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.954,
    cy: 43.6252,
    rx: 2.98696,
    ry: 7.50833,
    transform: "rotate(127.672 647.954 43.6252)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.052,
    cy: 45.9972,
    rx: 2.28415,
    ry: 5.74167,
    transform: "rotate(127.672 655.052 45.9972)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.759,
    cy: 49.9884,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(127.672 654.759 49.9884)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.177,
    cy: 55.5831,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(127.672 667.177 55.5831)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 648.306,
    cy: 46.7827,
    rx: 2.10844,
    ry: 7.06667,
    transform: "rotate(127.672 648.306 46.7827)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 669.165,
    cy: 54.4542,
    rx: 1.75704,
    ry: 4.41667,
    transform: "rotate(127.672 669.165 54.4542)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 674.712,
    cy: 63.1739,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(127.672 674.712 63.1739)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 677.879,
    cy: 63.4034,
    rx: 1.40563,
    ry: 3.53333,
    transform: "rotate(127.672 677.879 63.4034)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.733,
    cy: 52.1903,
    rx: 1.40563,
    ry: 4.85833,
    transform: "rotate(127.672 654.733 52.1903)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 664.489,
    cy: 50.3966,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(127.672 664.489 50.3966)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 660.942,
    cy: 52.0987,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(127.672 660.942 52.0987)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 661.751,
    cy: 55.3868,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(127.672 661.751 55.3868)",
    fill: "#81C241"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_if_6177_11816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 668.259,
    cy: 59.9669,
    rx: 2.10844,
    ry: 5.3,
    transform: "rotate(127.672 668.259 59.9669)",
    fill: "#81C241"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_if_6177_11816",
    x: 635.285,
    y: 36.6631,
    width: 13.5117,
    height: 13.8965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_if_6177_11816",
    x: 666.113,
    y: 53.1611,
    width: 12.7812,
    height: 13.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_if_6177_11816",
    x: 651.258,
    y: 38.9414,
    width: 15.707,
    height: 15.7188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_if_6177_11816",
    x: 636.094,
    y: 32.5615,
    width: 15.707,
    height: 15.7188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_if_6177_11816",
    x: 637.758,
    y: 28.9619,
    width: 15.707,
    height: 15.7188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_if_6177_11816",
    x: 644.965,
    y: 34.083,
    width: 15.707,
    height: 15.7188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_if_6177_11816",
    x: 639.734,
    y: 36.4619,
    width: 16.4375,
    height: 16.3262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_if_6177_11816",
    x: 648.297,
    y: 40.0488,
    width: 13.5117,
    height: 13.8965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_if_6177_11816",
    x: 648.367,
    y: 44.3438,
    width: 12.7812,
    height: 13.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_if_6177_11816",
    x: 660.785,
    y: 49.9385,
    width: 12.7812,
    height: 13.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_if_6177_11816",
    x: 640.562,
    y: 40.1514,
    width: 15.4844,
    height: 15.2627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_if_6177_11816",
    x: 663.508,
    y: 49.417,
    width: 11.3164,
    height: 12.0742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_if_6177_11816",
    x: 668.32,
    y: 57.5293,
    width: 12.7812,
    height: 13.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_if_6177_11816",
    x: 672.953,
    y: 58.9736,
    width: 9.85156,
    height: 10.8594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_if_6177_11816",
    x: 648.793,
    y: 47.0186,
    width: 11.8828,
    height: 12.3438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_if_6177_11816",
    x: 658.098,
    y: 44.752,
    width: 12.7812,
    height: 13.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_if_6177_11816",
    x: 654.551,
    y: 46.4541,
    width: 12.7812,
    height: 13.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_if_6177_11816",
    x: 655.359,
    y: 49.7422,
    width: 12.7812,
    height: 13.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_if_6177_11816",
    x: 661.867,
    y: 54.3223,
    width: 12.7812,
    height: 13.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6177_11816"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_6177_11816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6177_11816",
    x1: 292.757,
    y1: 56.7909,
    x2: 534.962,
    y2: 147.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#157E0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleVine);
export default __webpack_public_path__ + "static/media/middle_vine.15289c7122f0dcf09a724eb011668b06.svg";
export { ForwardRef as ReactComponent };